import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { actions as clipperMovieActions } from '../../actions/clipperMovie';
import { Button, ButtonIcon as BaseButtonIcon } from '../../styled-components';
import GraphicPreviewContainer from './GraphicPreviewContainer';
import MovieStream from './MovieStream';

const Container = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

const Controls = styled.div`
  text-align: center;
  z-index: 2;
  display: flex;
  justify-content: center;

  & > * {
    margin: 0.5rem 1rem;
  }
`;

const ButtonIcon = styled(BaseButtonIcon)`
  vertical-align: middle;
`;

class MoviePlayer extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.isPlaying !== this.props.isPlaying;
  }
  handleOnMainButtonClick() {
    if (this.props.isPlaying) {
      this.props.onPause();
    } else {
      this.props.onPlay();
    }
  }
  renderMainIcon() {
    return this.props.isPlaying ? (
      <ButtonIcon iconOnly src="images/pause.png" />
    ) : (
      <ButtonIcon iconOnly src="images/play.png" />
    );
  }
  render() {
    return (
      <Container>
        <GraphicPreviewContainer />
        <MovieStream />
        <Controls>
          <Button minHeight="1rem" onClick={() => this.props.onJumpToStart()}>
            <ButtonIcon iconOnly src="images/jump_to_start.png" />
          </Button>
          <Button minHeight="1rem" onClick={this.handleOnMainButtonClick.bind(this)}>
            {this.renderMainIcon()}
          </Button>
          <Button minHeight="1rem" onClick={() => this.props.onJumpToEnd()}>
            <ButtonIcon iconOnly src="images/jump_to_end.png" />
          </Button>
        </Controls>
      </Container>
    );
  }
}

MoviePlayer.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  onJumpToEnd: PropTypes.func.isRequired,
  onJumpToStart: PropTypes.func.isRequired,
  onPause: PropTypes.func.isRequired,
  onPlay: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isPlaying: state.clipperMovie.isPlaying
});

const mapDispatchToProps = {
  onJumpToEnd: clipperMovieActions.jumpVideoToEnd,
  onJumpToStart: clipperMovieActions.jumpVideoToStart,
  onPause: clipperMovieActions.pauseVideo,
  onPlay: clipperMovieActions.playVideo
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoviePlayer);



// WEBPACK FOOTER //
// ./app/components/Clipper/MoviePlayer.js